var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoColumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.5 3.74902C4.25736 3.74902 3.25 4.75638 3.25 5.99902V9.499C3.25 10.7416 4.25736 11.749 5.5 11.749H9C10.2426 11.749 11.25 10.7416 11.25 9.499V5.99902C11.25 4.75638 10.2426 3.74902 9 3.74902H5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15.499C3.25 14.2564 4.25736 13.249 5.5 13.249H9C10.2426 13.249 11.25 14.2564 11.25 15.499V18.999C11.25 20.2417 10.2426 21.249 9 21.249H5.5C4.25736 21.249 3.25 20.2417 3.25 18.999V15.499Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.75 15.499C12.75 14.2564 13.7574 13.249 15 13.249H18.5C19.7426 13.249 20.75 14.2564 20.75 15.499V18.999C20.75 20.2417 19.7426 21.249 18.5 21.249H15C13.7574 21.249 12.75 20.2417 12.75 18.999V15.499Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7491 3.55859C16.3349 3.55859 15.9991 3.89438 15.9991 4.30859V6.99906H13.3086C12.8944 6.99906 12.5586 7.33485 12.5586 7.74906C12.5586 8.16328 12.8944 8.49906 13.3086 8.49906H15.9991V11.19C15.9991 11.6043 16.3349 11.9401 16.7491 11.9401C17.1633 11.9401 17.4991 11.6043 17.4991 11.19V8.49906H20.19C20.6043 8.49906 20.94 8.16328 20.94 7.74906C20.94 7.33485 20.6043 6.99906 20.19 6.99906H17.4991V4.30859C17.4991 3.89438 17.1633 3.55859 16.7491 3.55859Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoColumn);
export default __webpack_public_path__ + "static/media/DuoColumn.a5635817269a1ad7a3261d4d198df182.svg";
export { ForwardRef as ReactComponent };